const LOCAL_STORAGE_KEY = '@@vkid/pkce';

function randomString(length: number) {
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  return btoa(String.fromCharCode(...array))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

export function createVKIDPkce() {
  const state = randomString(32);
  const codeVerifier = randomString(64);

  localStorage.setItem(
    LOCAL_STORAGE_KEY,
    btoa(
      JSON.stringify({
        state,
        codeVerifier,
      })
    )
  );

  return {
    state,
    codeVerifier,
  };
}

export function getVKIDPkce() {
  const dataStr = localStorage[LOCAL_STORAGE_KEY];

  delete localStorage[LOCAL_STORAGE_KEY];

  if (typeof dataStr !== 'string') {
    return null;
  }

  let parseResult: unknown = null;

  try {
    parseResult = JSON.parse(atob(dataStr));
    // eslint-disable-next-line no-empty
  } catch (_e) {}

  if (!parseResult || typeof parseResult !== 'object') {
    return null;
  }

  return parseResult as {
    state: string;
    codeVerifier: string;
  };
}
